import AbstractRule from './AbstractRule';
import {AnySchema, ArraySchema, NumberSchema} from 'yup';

export default class MaxRule extends AbstractRule {
	protected name = 'max';
	protected defaultParameters = [0];

	mutateScheme<S extends AnySchema>(scheme: S): S {
		if (scheme instanceof NumberSchema) {
			return scheme.max(this.getParameters()[0], 'Validator.should_be_less_than');
		}

		if (scheme instanceof ArraySchema) {
			return scheme.max(this.getParameters()[0], 'Validator.size_should_be_less_than');
		}

		return scheme;
	}
}
